const applyBackgroundImages = () => {
	const sections = document.querySelectorAll('.block-statistics[data-background-image]');
	sections.forEach(section => {
		const imageUrl = section.getAttribute('data-background-image');
		if (imageUrl) {
			section.style.backgroundImage = `url('${imageUrl}')`;
			section.style.backgroundSize = 'cover';
			section.style.backgroundPosition = 'center';
			section.style.backgroundRepeat = 'no-repeat';
		}
	});
};
// Run on frontend
document.addEventListener('DOMContentLoaded', () => {
	applyBackgroundImages();
});
// Run in the block editor (backend)
if (typeof wp !== 'undefined' && wp.domReady) {
	wp.domReady(() => {
		setTimeout(() => {
			applyBackgroundImages();
			// Optional: Watch for live block updates (uncomment if needed)
			const observer = new MutationObserver(() => {
				applyBackgroundImages();
			});
			observer.observe(document.body, {
				childList: true,
				subtree: true,
			});
		}, 500);
	});
}
